import { Component, OnInit } from '@angular/core';
import { InconformidadLaboratorioEntity, ServicioLaboratorioService, InconformidadLaboratorioBodyEntity } from 'src/app/services/servicio-laboratorio.service';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ImagesService } from 'src/app/services/utils/images.service';

@Component({
  selector: 'app-reporte-inconformidad-agenda',
  templateUrl: './reporte-inconformidad-agenda.component.html',
  styleUrls: ['./reporte-inconformidad-agenda.component.css']
})
export class ReporteInconformidadAgendaComponent implements OnInit {

  loading: boolean = false;
  user: string;
  fechaImpresion: Date;

  logo: string;

  filtrosSeleccionados: InconformidadLaboratorioEntity;
  detalle: InconformidadLaboratorioBodyEntity[] = [];

  public objectInconformidad : InconformidadLaboratorioEntity = {
    codigo : '',
    fechaInicial : 0,
    fechaFinal : 0,
    sedePuntoAtencion : -1,
    descripcionSedePuntoAtencion : '',
    activaJustificacion : true
  }

  constructor( private activatedRoute: ActivatedRoute,
               private servicioImagenes: ImagesService,
               private servicioLaboratorio: ServicioLaboratorioService ) {
    this.activatedRoute.params.subscribe(params => {
      this.objectInconformidad.codigo = params['codigoBaseDatos'];
      this.objectInconformidad.sedePuntoAtencion = params['spa'];
      this.user = params['user'];
    });
  }

  ngOnInit() {
    this.filtrosSeleccionados = this.objectInconformidad;
    this.fechaImpresion = new Date();
    this.getLogo(this.objectInconformidad.codigo);
  }

  public onFiltrosCompletados(obj: InconformidadLaboratorioEntity){
    this.loading = true;
    this.filtrosSeleccionados = obj;
    this.fechaImpresion = new Date();
    this.getLogo(this.objectInconformidad.codigo);
    this.getData();
  }

  async getLogo(codigoBaseDatos: string){
    try{
      this.logo = '';
      let response = await this.servicioImagenes.getLogo(codigoBaseDatos);
      if(response != null){
        response.subscribe((data: any) => {
          this.logo = data.source;
        }, (err: HttpErrorResponse) => {
          this.logo = '';
        })
      }
    }catch(e){
      this.logo = '';
    }
  }

  async getData(){
    try{
      let response = await this.servicioLaboratorio.getInconformidadesData(this.filtrosSeleccionados);
      if(response != null){
        response.subscribe((data: InconformidadLaboratorioBodyEntity[]) => {
          this.detalle = data;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          console.error('Error getData()', err)
          this.detalle = [];
          this.loading = false;
        })
      }
    }catch(e){
      console.error('Catch getData()', e);
      this.loading = false;
    }
  }

}
